import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Testimonials } from './components/Testimonials';
import { BeforeAfter } from './components/BeforeAfter';
import { HowItWorks } from './components/HowItWorks';
import { ProductSection } from './components/ProductSection';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Story data-id="element-4" />
        <BeforeAfter data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Testimonials data-id="element-7" />
        <ProductSection data-id="element-8" />
        <Footer data-id="element-9" />
      </main>
      <CookieBanner data-id="element-10" />
    </div>;
}